function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";
import styled from "styled-components";
import { space, color } from "styled-system";
var Svg = styled("svg")({
  flex: "none"
}, space, color);
var SvgStart = React.forwardRef(function (props, ref) {
  return React.createElement(Svg, _extends({}, props, {
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    height: props.size,
    width: props.size,
    ref: ref
  }), React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z",
    fill: "inherit"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.802 14.168c-.01 1.555-.909 2.88-2.342 3.423a9.186 9.186 0 01-1.033.308c-.208.053-.321.156-.338.383-.02.287-.05.572-.09.855-.048.334-.163.411-.47.337-.53-.125-.586-.211-.516-.767.006-.047.013-.094.018-.142.053-.456-.012-.52-.448-.499-.196.01-.277.107-.296.299-.026.276-.053.552-.098.825-.044.278-.162.348-.43.289-.573-.124-.615-.188-.54-.793.095-.753.092-.744-.602-.954-.308-.093-.606-.222-.907-.341-.183-.072-.243-.208-.193-.412.063-.258.106-.523.16-.785.093-.446.309-.581.722-.42.73.288 1.48.465 2.26.484.705.017 1.402-.03 2.044-.375.425-.229.737-.564.894-1.045.232-.714.024-1.291-.645-1.579-.552-.236-1.143-.367-1.699-.594-.494-.2-1.007-.402-1.432-.717-.958-.709-1.125-1.755-.915-2.874.238-1.26 1.01-2.078 2.155-2.512.305-.115.443-.276.448-.618.005-.372.064-.743.11-1.112.034-.285.145-.364.41-.32.564.092.632.18.576.767-.021.228-.04.457-.067.684-.023.191.038.28.238.285.457.014.476.005.53-.467.035-.304.06-.608.102-.911.045-.336.154-.413.463-.35.521.108.58.187.528.73-.022.238-.033.478-.075.713-.047.27.036.395.304.457.51.119 1.016.269 1.518.425.377.117.392.16.32.551-.043.235-.086.47-.142.702-.103.437-.32.567-.736.427-.711-.24-1.425-.457-2.179-.489-.66-.027-1.31-.018-1.884.397-.807.584-.811 1.77.047 2.27.546.318 1.177.48 1.768.713.361.143.732.266 1.078.438.929.464 1.394 1.239 1.384 2.314",
    fill: "white"
  }));
});
SvgStart.displayName = "SvgStart";
SvgStart.defaultProps = {
  size: 24,
  color: "#01AEF0"
};
export default SvgStart;